import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {UsuarioService} from 'src/app/services/usuario.service';
import {Cookie} from 'src/app/model/cookie.model';
import {AlertService} from 'src/app/component/Alert/alert.service';
import {GoogleAnalyticsService} from 'src/app/services/google-analytics.service';
import {Mask} from 'src/app/model/mask.model';
import {NotificationsService} from 'angular2-notifications';
import {RecaptchaComponent} from 'ng-recaptcha';
import {first} from 'rxjs/operators';
import {ConfigurationService} from 'src/app/services/configuration.service';
import {CustomSiteService} from '../../services/customsite.service';
import {ModalDismissReasons, NgbModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  model: any = {};
  cookiesEnabled : boolean = true;
  reCaptchaKey: string;
  features: any = { login: [ "docs", "email" ], signUp: true };
  captchaToken: string = '';
  showSpinner: boolean = false;
  agenciaSelecionada: Number;
  pageTitle = "Atendimento - Pagmob";
  loginText = "A Pagmob facilita ainda mais o seu atendimento de forma simples, rápida e 100% online.";
  loginObs = "<strong>Aviso importante</strong>: O LOGIN É PESSOAL E INTRANSFERÍVEL. Evite sair de casa e cuide de sua saúde.<br/>";
  popUp = "";
  privacy = "";
  closeResult: string;

  public cpfmask = Mask.cpf;

  constructor(
    private router: Router,
    private usuarioService: UsuarioService,
    private alertService: AlertService,
    private _notificationService: NotificationsService,
    public googleAnalyticsService: GoogleAnalyticsService,
    private configService: ConfigurationService,
    private customSiteService: CustomSiteService,
    private modalService: NgbModal
    ) {
      this.onConfigLoad = this.onConfigLoad.bind(this);
      configService.loadConfigurations().subscribe( this.onConfigLoad );
    }

    ngOnInit() {
    try{
      this.googleAnalyticsService.eventEmitter("login", "load", "page-load", 1);
      localStorage.removeItem('cookie');
      localStorage.removeItem('usuario');
      const pageTitle = sessionStorage.getItem("pageTitle");
      const loginText = sessionStorage.getItem("loginText");
      localStorage.setItem("agenciaSelecionada", JSON.stringify(this.agenciaSelecionada));
      if(pageTitle == null && loginText == null)
        this.customSiteService.login(this.agenciaSelecionada).subscribe(customsite => {
          if(customsite.pageTitle) {
            this.pageTitle = customsite.pageTitle;
            sessionStorage.setItem("pageTitle",this.pageTitle);
          }
          if(customsite.pageTitle) {
            this.loginText = customsite.loginText;
            sessionStorage.setItem("loginText",this.loginText);
          }
          if(customsite.loginObs) {
            this.loginObs = customsite.loginObs;
            sessionStorage.setItem("loginObs",this.loginObs);
          }
          if(customsite.popUp) {
            this.popUp = customsite.popUp;
            sessionStorage.setItem("popUp",this.popUp);
          }
          if(customsite.privacy) {
            this.privacy = customsite.privacy;
            sessionStorage.setItem("privacy",this.privacy);
          }
          if(customsite.termsAcceptance) {
            sessionStorage.setItem("termsAcceptance",customsite.termsAcceptance);
          }
          if(customsite.register) {
            sessionStorage.setItem("register",customsite.register);
          }
        });
      else {
        this.pageTitle = pageTitle;
        this.loginText = loginText;
        this.loginObs = sessionStorage.getItem("loginObs");
        this.popUp = sessionStorage.getItem("popUp");
        this.privacy = sessionStorage.getItem("privacy");
      }

      RecaptchaComponent.prototype.ngOnDestroy = function() {
        if (this.subscription) {
          this.subscription.unsubscribe();
        }
      }
      } catch{
        this.cookiesEnabled = false;
      }
    }

    efetuarLogin() {
    //if (!this.model.token || this.model.token === '') {
    //  grecaptcha.reset();
    //  this._notificationService.error('Login', "Selecione a opção 'Não sou um robô' ante de realizar o login.");
    //  return;
    //}
      const agenciaSelecionada = JSON.parse(localStorage.getItem("agenciaSelecionada"));
      console.log(agenciaSelecionada)

      this.model.agencyId = agenciaSelecionada;
      console.log(this.model)

      this.showSpinner = true;
      if (this.model.cpf) {
        this.model.cpf =  this.model.cpf.replace(/[&\/\\#,+()$~%.'":*?<>{}]/g, '');
        this.model.cpf =  this.model.cpf.replace('-', '');
      }

      if (this.model.rg) {
        this.model.rg =  this.model.rg.replace(/[&\/\\#,+()$~%.'":*?<>{}]/g, '');
        this.model.rg =  this.model.rg.replace('-', '');
      }

      this.googleAnalyticsService.eventEmitter("login", "button-click", "tentativa-login", 2);

      this.usuarioService.auth(this.model).subscribe(authResult => {
        this.usuarioService.efetuarLogin(this.model, authResult).pipe(first()).subscribe(resUsuario => {
          this.usuarioService.getToken(this.model.agencyId).subscribe((resCookie: Cookie) => {
             if( !resCookie ) {
               this.showSpinner = false;//prevent from loading forever
               this._notificationService.error('Erro', "Erro ao obter cookie token.");
             }
            this.googleAnalyticsService.eventEmitter("login", "button-click", "sucesso", 3);
            if(resCookie){
            localStorage.setItem('cookie', JSON.stringify(resCookie.cookie));
          }
            resUsuario.senha = '';
            localStorage.setItem('usuario', JSON.stringify(resUsuario));
            this.router.navigate(['app/dashboard']);
          },
          (err) => {
            this.showSpinner = false;
            this._notificationService.error('Erro ao obter cookie token', err);
            grecaptcha.reset();
          });
        }, (e) => {
          this.showSpinner = false;
          if(e && e.error && e.error.message) this._notificationService.error('Erro ao efetuar login', e.error.message);
          grecaptcha.reset();
        });
      }, (err) => {
        this.showSpinner = false;
        if(err.error != undefined && err.error.error == "invalid_grant" && err.error.error_description == "Bad credentials")
          this._notificationService.error('Login inválido', 'Login ou senha inválido');
        else this._notificationService.error('Erro ao autenticar', err.error.message);
        grecaptcha.reset();
      });
    }

    resolved(captchaResponse: string) {
      this.model.token = captchaResponse;
      this.captchaToken = captchaResponse;
    }

    onConfigLoad( config ) {
      this.reCaptchaKey = config.reCaptchaKey;
      this.agenciaSelecionada = config.agencyId;
      if ( config.features ) {
        this.features = config.features;
      }
    }

    cookieShow() {
      return localStorage.getItem("privacynoticedismiss") == undefined;
    }

    cookieDismiss() {
      return localStorage.setItem("privacynoticedismiss", "true");
    }

    private getDismissReason(reason: any): string {
      if (reason === ModalDismissReasons.ESC) {
        return 'by pressing ESC';
      } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
        return 'by clicking on a backdrop';
      } else {
        return  `with: ${reason}`;
      }
    }

    openModal(content) {
      this.modalService.open(content, {size: 'lg', backdrop: 'static', ariaLabelledBy: 'modalInfoLabel'}).result.then((result) => {
        this.closeResult = `Closed with: ${result}`;
      }, (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      });
    }


  }
